"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.isSemanticElement = exports.extractDisplayName = void 0;
var react_1 = __importDefault(require("react"));
// Noting that this is contingent on our displayName for our components -  this something we control
var allowedDisplayNames = ["Button", "IconButton", "FilterButtonBase"];
function extractDisplayName(type) {
    return type.displayName || type.name || "Unknown";
}
exports.extractDisplayName = extractDisplayName;
/**
 *  Validates implicit or explicitly semantic roles required to make `aria-describedby` announce predictably with screen readers
 */
var isSemanticElement = function (element) {
    if (!react_1["default"].isValidElement(element))
        return false;
    var props = element.props, type = element.type;
    if ("role" in props) {
        return props.role !== "presentation" && props.role !== "none";
    }
    if (typeof type !== "string") {
        // As we are only checking whether this matches to our allowedDisplayNames
        // type casting should be fine
        var displayName = extractDisplayName(type);
        return allowedDisplayNames.includes(displayName);
    }
    return !(type === "div" || type === "span");
};
exports.isSemanticElement = isSemanticElement;
//# sourceMappingURL=isSemanticElement.js.map